import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppRouter } from '../../router/AppRouter';
import { PendingTakeoverProvider } from '../../contexts/PendingTakeoverContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

export const App = () => {
    return (
        <QueryClientProvider client={queryClient}>
            <Router>
                <PendingTakeoverProvider>
                    <AppRouter />
                </PendingTakeoverProvider>
            </Router>
        </QueryClientProvider>
    );
};
